import React from 'react';
import { List, ListItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { FlamingoFund } from 'funds-model';
import { Card } from '../Card/Card';
import { Tabs, TabPanel, useTabs } from '../Tabs/Tabs';

import useStyles from './FundDetailsDialog.style';

export interface FundDetailsDialogAboutProps {
  fund: FlamingoFund;
}

const FundDetailsDialogAbout: React.FC<FundDetailsDialogAboutProps> = ({ fund }) => {
  const c = useStyles({});
  const [t] = useTranslation('components');
  const { handleTabChange: handleTabChangeInfo, tabValue: tabValueInfo } = useTabs();

  const goalsAndInvestmentPolicies = fund.goalsAndInvestmentPolicies.filter(policy => policy.value.trim().length > 0)
                                                                    .sort((a,b) => a.seq - b.seq)
                                                                    .map(policy => policy.value);
  const forWhom = fund.forWhom.filter(f => f.value.trim().length > 0)
                              .sort((a, b) => a.seq - b.seq)
                              .map(f => f.value);

  const renderBulletText = (bulletText: string, index?: number) => <ListItem key={index}>{bulletText}</ListItem>;

  const renderBulletsSection = (texts: string[]) => (
    <div>
      <List className={c.bulletsListWrapper}>
        {texts.map(renderBulletText)}
      </List>
    </div>
  );

  const getTabLabels = () => {
    const labels = [];
    if (fund.shortText1) {
      labels.push(t('fund-details-dialog.about-fund'));
    }
    if (forWhom && forWhom.length > 0) {
      labels.push(t('fund-details-dialog.for-whom'));
    }
    if (goalsAndInvestmentPolicies && goalsAndInvestmentPolicies.length > 0) {
      labels.push(t('fund-details-dialog.how-we-manage'));
    }
    return labels;
  }

  if (getTabLabels().length === 0) {
    return null;
  }

  const getGoalsAndInvestmentPoliciesTabIndex = () => {
    if ((!fund.shortText1 || fund.shortText1.length === 0) && (!forWhom || forWhom.length === 0)) {
      return 0;
    }
    if (fund.shortText1.length > 0 && forWhom.length > 0) {
      return 2;
    }
    return 1;
  }

  return (
    <Card size="equal">
      <Tabs value={tabValueInfo}
        handleChange={handleTabChangeInfo}
        labels={getTabLabels()}
        className={c.aboutTabs} />
      <TabPanel
        className={c.tabPanel}
        value={tabValueInfo}
        index={0}
      >
        {fund.shortText1}
      </TabPanel>
      <TabPanel
        className={c.tabPanel}
        value={tabValueInfo}
        index={(!fund.shortText1 || fund.shortText1.length === 0) ? 0 : 1}
        >
        {forWhom && forWhom.length > 0 &&
          renderBulletsSection(forWhom)}
      </TabPanel>
      <TabPanel className={c.tabPanel} value={tabValueInfo} index={getGoalsAndInvestmentPoliciesTabIndex()}>
        {goalsAndInvestmentPolicies && goalsAndInvestmentPolicies.length > 0 &&
          renderBulletsSection(goalsAndInvestmentPolicies)}
      </TabPanel>
    </Card>
  );
};

export default FundDetailsDialogAbout;
